import { createFileRoute } from "@tanstack/react-router";
import AdminRealCases from "@/pages/admin/AdminRealCases";

export const Route = createFileRoute("/admin/casos-reales")({ component: AdminRealCases });
